import { z } from 'zod';
import { CandidateCommunicationAlertsSchema } from '@axiom/validation';

export const PreferencesCommunicationsFormSchema =
  CandidateCommunicationAlertsSchema.extend({
    TIMEZONE_DROPDOWN: z.string().uuid().optional(),
  });

export type PreferencesCommunicationsForm = z.infer<
  typeof PreferencesCommunicationsFormSchema
>;
